import { Nav, NavItem, NavLink } from "reactstrap";
import { Href } from "../../../Utils/Constants";
import { getSystemConfig } from "../../../sharedFunctions/SystemConfig";

type propsType = {
    basicTab: string;
    setBasicTab: (data: string) => void;
}

export default function ApprovalNav({ basicTab, setBasicTab }: propsType) {
    const geoVal = String(getSystemConfig("enable_geo_fencing") || "").trim().toLowerCase();
    const isGeofencingActive = geoVal === 'on' || geoVal === 'yes' || geoVal === 'true' || geoVal === '1';

    return (
        <Nav tabs className='border-tab nav-info mb-0'>
            <NavItem>
                <NavLink href={Href} className={`nav-border txt-info tab-info ${basicTab === '1' ? 'active' : ''}`} onClick={(e) => { e.preventDefault(); setBasicTab('1'); }}><i className="icofont icofont-ui-home" />{'MTP Approval'}</NavLink>
            </NavItem>
            <NavItem>
                <NavLink href={Href} className={`nav-border txt-info tab-info ${basicTab === '2' ? 'active' : ''}`} onClick={(e) => { e.preventDefault(); setBasicTab('2'); }}><i className="icofont icofont-ui-message" />{'Leave Approval'}</NavLink>
            </NavItem>
            <NavItem>
                <NavLink href={Href} className={`nav-border txt-info tab-info ${basicTab === '3' ? 'active' : ''}`} onClick={(e) => { e.preventDefault(); setBasicTab('3'); }}><i className="icofont icofont-man-in-glasses" />{'Expense Approval'}</NavLink>
            </NavItem>
            <NavItem>
                <NavLink href={Href} className={`nav-border txt-info tab-info ${basicTab === '4' ? 'active' : ''}`} onClick={(e) => { e.preventDefault(); setBasicTab('4'); }}><i className="icofont icofont-file-text" />{'POD Approval'}</NavLink>
            </NavItem>
            <NavItem>
                <NavLink href={Href} className={`nav-border txt-info tab-info ${basicTab === '5' ? 'active' : ''}`} onClick={(e) => { e.preventDefault(); setBasicTab('5'); }}><i className="icofont icofont-listine-dots" />{'POD Summary'}</NavLink>
            </NavItem>
            <NavItem>
                <NavLink href={Href} className={`nav-border txt-info tab-info ${basicTab === '6' ? 'active' : ''}`} onClick={(e) => { e.preventDefault(); setBasicTab('6'); }}><i className="icofont icofont-support" />{'Support Approval'}</NavLink>
            </NavItem>
            <NavItem>
                <NavLink href={Href} className={`nav-border txt-info tab-info ${basicTab === '7' ? 'active' : ''}`} onClick={(e) => { e.preventDefault(); setBasicTab('7'); }}><i className="icofont icofont-box" />{'Closing Stock Approval'}</NavLink>
            </NavItem>
            <NavItem>
                <NavLink href={Href} className={`nav-border txt-info tab-info ${basicTab === '8' ? 'active' : ''}`} onClick={(e) => { e.preventDefault(); setBasicTab('8'); }}><i className="icofont icofont-sun-alt" />{'Holiday Approvals'}</NavLink>
            </NavItem>
            {isGeofencingActive && (
                <NavItem>
                    <NavLink href={Href} className={`nav-border txt-info tab-info ${basicTab === '9' ? 'active' : ''}`} onClick={(e) => { e.preventDefault(); setBasicTab('9'); }}><i className="icofont icofont-location-pin" />{'GeoFencing Approvals'}</NavLink>
                </NavItem>
            )}
        </Nav>
    )
}
